import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import PlayerMatchupPattern from '@mlb/react-patterns/components/PlayerMatchup/playerMatchup.tsx';
import { PlayerMatchupTypes, PitchingDecisionTypes } from '@mlb/react-patterns/components/PlayerMatchup/playerMatchup.types';
import Skeleton from '@mlb/react-patterns/components/Skeleton/skeleton.tsx';

import Stats from 'bdvp-common/src/components/Metadata/PlayerMatchup/Stats';
import { useBasePath } from 'bdvp-common/src/hooks/config';
import { SEARCH_ROUTE } from 'bdvp-common/src/utils/constants';

import { Tracking } from 'bdvp-tracking';

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const StatsWrapper = styled.div`
    flex: 0 0 60px;
    margin-left: 8px;
`;

export const getStats = (wins = -1, losses = -1, era) => {

    const stats = [];
    if (wins >= 0 && losses >= 0) {

        stats.push(`${wins} - ${losses}`);

    }
    if (era) {

        stats.push(`${era} ERA`);

    }
    return stats.join(' | ');

};

const PlayerMatchup = (props) => {

    const {
        player,
        decision,
        loading,
    } = props;

    const {
        id,
        name,
        innings,
        earnedRuns,
        strikeouts,
        era,
        wins,
        losses,
        saves,
    } = player;

    const basePath = useBasePath();
    const history = useHistory();

    const searchParams = `?q=${encodeURIComponent(`PlayerId = [${id}] Order by Timestamp DESC`)}`;

    const playerClickHandler = (e) => {

        e.preventDefault();
        Tracking.trackGameIndexPagePlayerClick(name);

        history.push({
            pathname: SEARCH_ROUTE,
            search: searchParams,
        });

    };

    if(!loading && !id) {

        return null;

    }

    const playerStats = [
        {
            value: innings,
            label: 'IP',
        },
        {
            value: earnedRuns,
            label: 'ER',
        },
        {
            value: strikeouts,
            label: 'SO',
        },
    ];

    return (
        <Wrapper>
            <PlayerMatchupPattern
                type={PlayerMatchupTypes.PITCHERPOSTGAME}
                decision={decision}
                playerId={id}
                name={name}
                playerStats={decision === PitchingDecisionTypes.SV ? saves : getStats(wins, losses, era)}
                headshotWidth={'52px'}
                linkProps={{
                    handlers: {
                        onClick: playerClickHandler,
                    },
                    url: `${basePath}${SEARCH_ROUTE}${searchParams}`,
                }}
                isLoading={loading}
            />
            <StatsWrapper>
                {loading ? (
                    playerStats.map((e, i) => <Skeleton key={i} height={12} width={'100%'}/>)
                ) : (
                    <Stats data={playerStats} />
                )}
            </StatsWrapper>
        </Wrapper>
    );

};

PlayerMatchup.propTypes = {
    loading: PropTypes.bool,
    player: PropTypes.object,
    decision: PropTypes.string,
};

PlayerMatchup.defaultProps = {
    loading: true,
    player: {},
    decision: '',
};

export default PlayerMatchup;
